module.exports = "<form ng-submit=\"vm.validate_address()\" class=\"order-creation-first-page\">\n  <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n    <label>Address* <span class=\"order-error-text\" ng-show=\"vm.address_ui.error\">- {{vm.address_ui.error_msg}}</span></label>\n    <input\n      type=\"text\"\n      class=\"form-control form-input\"\n      placeholder=\"100 Main Street Boston MA\"\n      ng-model=\"vm.address\"\n      ng-change=\"vm.address_change()\"\n      ng-class=\"{'order-error':vm.address_ui.error}\"\n      googleplace\n    />\n  </div>\n</form>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/common/googleplaces/googleplaces.html
// module id = 151
// module chunks = 0